import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-arrow-left-slim',
    templateUrl: './icon-arrow-left-slim.component.html',
    styleUrls: ['./icon-arrow-left-slim.component.scss']
})
export class IconArrowLeftSlimComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit(): void {
    }

}
